import '@shui/core/sh-modal';

import { Component, input, booleanAttribute, output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sh-modal',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.accessible-close-label]': 'accessibleCloseLabel() ?? null',
        '[attr.icon]': 'icon() ?? null',
        '[attr.icon-color]': 'iconColor() ?? null',
        '[attr.label]': 'label() ?? null',
        '[attr.label-rows]': 'labelRows() ?? null',
        '[attr.modal-height]': 'modalHeight() ?? null',
        '[attr.modal-width]': 'modalWidth() ?? null',
        '[attr.sticky]': 'sticky() ? "" : null',
        '[attr.type]': 'type() ?? null',
        '[attr.visible]': 'visible() ? "" : null',
        '(modal-closed)': 'modalClosed.emit($event)'
    }
})
export class ShModalComponent {
    /**
     * If the `accessibleCloseLabel` property is not set, the icon will use the `type` to
     * dynamically set the `label`.
     */
    public readonly accessibleCloseLabel = input<string | number | undefined>(undefined);

    /** Optional property that reflects the icon of the modal. */
    public readonly icon = input<string | number | undefined>(undefined);

    /** Sets the color of the icon added through `icon` property. */
    public readonly iconColor = input<string | number | undefined>(undefined);

    /**
     * Defines the label shown at the top of the Modal (won't be shown if the header slot is
     * occupied).
     */
    public readonly label = input<string | number | undefined>(undefined);

    /** Allows longer labels to wrap to multiple lines. */
    public readonly labelRows = input<string | number | undefined>(undefined);

    /** Defines the height of the modal. Takes a number or css attribute (e.g. fit-content). */
    public readonly modalHeight = input<string | number | undefined>(undefined);

    /** Defines the width of the modal. Takes a number or css attribute (e.g. fit-content). */
    public readonly modalWidth = input<string | number | undefined>(undefined);

    /**
     * Defines that the modal can only be closed through actions present in the modal. The close
     * icon will also be hidden.
     */
    public readonly sticky = input(false, { transform: booleanAttribute });

    /**
     * Defines the type of modal that will be displayed. Accepted values are alert, error,
     * confirmation, success, and warning.
     */
    public readonly type = input<string | number | undefined>(undefined);

    /** Defines if the modal is shown or not. */
    public readonly visible = input(false, { transform: booleanAttribute });

    public readonly modalClosed = output<Event>();
}
